export class PopulationSegment {
  id: number;
  name: string;
  /** Live launches currently pointing at this segment — powers the
      shared-population warning when picking one that's already in use. */
  launch_count: number;

  constructor() {
    this.id = -1;
    this.name = "";
    this.launch_count = 0;
  }

  static fromJson(data: any): PopulationSegment {
    const seg = new PopulationSegment();
    seg.id = data?.id ?? -1;
    seg.name = data?.name ?? "";
    seg.launch_count = data?.launch_count ?? 0;
    return seg;
  }

  static fromJsonList(data: any[]): PopulationSegment[] {
    return (data ?? []).map(PopulationSegment.fromJson);
  }
}
